import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { setProfil } from '../../redux';
import Nav from '../../layouts/Nav';
import Login from '../../layouts/Login';
import "./style.css"

function Body() {
    const dispatch = useDispatch();
    const [wait, setWait] = useState(true);
    const state = useSelector(state => state.profil);

    useEffect(() => {
        let email = localStorage.getItem('email');
        let password = localStorage.getItem('password');

        if (!email || !password) {
            email = sessionStorage.getItem('email');
            password = sessionStorage.getItem('password');
        }

        if (!email || !password) return setWait(false);
        fetchLogin(email, password);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const fetchLogin = async (email, password) => {
        const req = await fetch(`${process.env.REACT_APP_API_URL}/users/login`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, password })
        })
        const res = await req.json();
        setWait(false);

        if (req.status !== 200) {
            sessionStorage.removeItem('email');
            sessionStorage.removeItem('password');
            localStorage.removeItem('email');
            localStorage.removeItem('password');
            return
        }

        const { token, ...resFiltered } = res;

        sessionStorage.setItem('status', res.status);
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('email', email);
        sessionStorage.setItem('password', password);

        dispatch(setProfil(resFiltered));
    }

    return !wait && (
        <div className="page_body">
            {state._id !== '' && <Nav />}
            {state._id !== '' && <Outlet />}
            {state._id === '' && <Login />}
        </div>
    )
}

export default Body;